import React from "react";
import { FilterBar, Menu, SearchBar, Select } from "@sscs/ui";
import { produce } from "immer";
import { CRYPTO_ASSET_KIND, CRYPTO_ASSET_KIND_LABEL, } from "../../../../constants";
import { initFilter, selectFilteredByLink } from "../../../../store/cbomSlice";
import { useReportSelector } from "../../../hooks";
import { isFilteredByLink } from "../../../utils";
import styles from "./filter.module.scss";
const valueIsCryptoAssetKind = (value) => Object.values(CRYPTO_ASSET_KIND).some((kind) => kind === value);
const Filter = ({ filter, onFilterChange }) => {
    var _a, _b;
    const filteredByLink = useReportSelector(selectFilteredByLink);
    return (React.createElement(FilterBar, { filters: [
            {
                id: "type",
                minWidth: "300px",
                control: (React.createElement(SearchBar, { id: "cryoto-asset-type-search", value: (_a = filter.type) !== null && _a !== void 0 ? _a : "", onChange: (value) => onFilterChange(produce(filter, (draftState) => {
                        draftState.type = value === "" ? null : value;
                    })), label: "Regex search for crypto asset type", slotProps: { htmlInput: { maxLength: 256 } }, className: styles["search-bar"], "data-filtered-by-link": isFilteredByLink(filter, initFilter, "type", filteredByLink) })),
            },
            {
                id: "kind",
                width: "250px",
                control: (React.createElement(Select, { label: "Filter by crypto asset kind", id: "crypto-asset-kind-filter", labelId: "crypto-asset-kind-filter-label", displayEmpty: true, shrinkLabel: true, value: (_b = filter.kind) !== null && _b !== void 0 ? _b : "ALL", onChange: (value) => onFilterChange(produce(filter, (draftState) => {
                        if (value === "ALL") {
                            draftState.kind = null;
                        }
                        else if (valueIsCryptoAssetKind(value)) {
                            draftState.kind = value;
                        }
                    })), className: styles.dropdown, "data-filtered-by-link": isFilteredByLink(filter, initFilter, "kind", filteredByLink) },
                    React.createElement(Menu.Item, { id: "show-all-kinds", value: "ALL" }, "Show all crypto assets"),
                    React.createElement(Menu.Item, { id: "filter-by-algorithm", value: CRYPTO_ASSET_KIND.algorithm }, CRYPTO_ASSET_KIND_LABEL[CRYPTO_ASSET_KIND.algorithm]),
                    React.createElement(Menu.Item, { id: "filter-by-certificate", value: CRYPTO_ASSET_KIND.certificate }, CRYPTO_ASSET_KIND_LABEL[CRYPTO_ASSET_KIND.certificate]),
                    React.createElement(Menu.Item, { id: "filter-by-material", value: CRYPTO_ASSET_KIND.material }, CRYPTO_ASSET_KIND_LABEL[CRYPTO_ASSET_KIND.material]),
                    React.createElement(Menu.Item, { id: "filter-by-protocol", value: CRYPTO_ASSET_KIND.protocol }, CRYPTO_ASSET_KIND_LABEL[CRYPTO_ASSET_KIND.protocol]))),
            },
        ] }));
};
export default Filter;
//# sourceMappingURL=Filter.js.map